import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import Home from './Home'
import About from './About'
import Model from './Model'
import Framework from './Framework'
import FrameworkList from './FrameworkList'
import CategoryList from './CategoryList'
import Category from './Category'
import Collection from './Collection'
import Blog from './Blog'
import BlogPost from './BlogPost'

import ReactGA from 'react-ga';
ReactGA.initialize('UA-119876905-1');

 class Analytics extends Component {
  constructor(props) {
    super(props)

    // Initial page load - only fired once
    this.sendPageChange(props.location.pathname, props.location.search)
  }

  componentWillReceiveProps(nextProps) {
    // When props change, check if the URL has changed or not
    if (this.props.location.pathname !== nextProps.location.pathname
      || this.props.location.search !== nextProps.location.search) {
      this.sendPageChange(nextProps.location.pathname, nextProps.location.search)
    }
  }

  sendPageChange(pathname, search='') {
    const page = pathname + search
    ReactGA.set({page});
    ReactGA.pageview(page);
  }

  render() {
    return null
  }
}

const NoMatch = ({ location }) => (
  <div>
    <Helmet>
      <title>Model Zoo - Page not found!</title>
    </Helmet>
    <h1>Whoops!</h1>
    <p>You must have taken a wrong turn! Follow our navbar (above) to get back somewhere safe.</p>
  </div>
)

class Main extends Component {
  render() {
    return <div className="container main-container">
      <Switch>
        <Route exact path='/' render={ props => <div><Home categories={this.props.categories} frameworks={this.props.frameworks} {...props} /><Analytics {...props}/></div> } />
        <Route path='/about' render={ props => <div><About {...props} /><Analytics {...props}/></div> } />
        <Route path='/model/:slug' render={ props => <div><Model categories={this.props.categories} frameworks={this.props.frameworks} {...props} /><Analytics {...props}/></div> } />
        <Route path='/framework/:slug' render={ props => <div><Framework categories={this.props.categories} frameworks={this.props.frameworks} {...props} /><Analytics {...props}/></div> } />
        <Route path='/frameworks' render={ props => <div><FrameworkList frameworks={this.props.frameworks} {...props} /><Analytics {...props}/></div> } />
        <Route path='/collection/:slug' render={ props => <div><Collection categories={this.props.categories} frameworks={this.props.frameworks} {...props} /><Analytics {...props}/></div> } />
        <Route path='/category/:slug' render={ props => <div><Category categories={this.props.categories} frameworks={this.props.frameworks} {...props} /><Analytics {...props}/></div> } />
        <Route path='/categories' render={ props => <div><CategoryList categories={this.props.categories} {...props} /><Analytics {...props}/></div> } />
        <Route path='/blog/:slug' render={ props => <div><BlogPost {...props} /><Analytics {...props}/></div> } />
        <Route path='/blog' render={ props => <div><Blog {...props}/><Analytics {...props}/></div> } />
        <Route component={NoMatch} />
      </Switch>
    </div>
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/Main.jsx